import { render } from "./SelectDate.vue?vue&type=template&id=6e875877"
import script from "./SelectDate.vue?vue&type=script&lang=ts"
export * from "./SelectDate.vue?vue&type=script&lang=ts"
script.render = render

export default script